import { render, staticRenderFns } from "./selectAccess.vue?vue&type=template&id=19a5dd2b&"
import script from "./selectAccess.vue?vue&type=script&lang=js&"
export * from "./selectAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports